import { whyCarii } from '../../content/whyCarii.js';
import { RiseCard } from '../RiseCard/RiseCard.js';

export function WhyCarii() {
  return (
    <section
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: 'clamp(46px,7vw,72px) clamp(18px,5vw,64px) 0',
      }}
    >
      <div
        style={{
          font: "700 11.5px/1 'Plus Jakarta Sans',sans-serif",
          letterSpacing: '.09em',
          color: 'var(--faint)',
          textTransform: 'uppercase',
          marginBottom: '14px',
        }}
      >
        {whyCarii.eyebrow}
      </div>
      <h2
        style={{
          margin: '0 0 28px',
          maxWidth: '22ch',
          font: "800 clamp(26px,3.4vw,38px)/1.12 'Plus Jakarta Sans',sans-serif",
          letterSpacing: '-.03em',
          color: 'var(--ink)',
        }}
      >
        {whyCarii.title}
      </h2>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%,240px), 1fr))',
          gap: '15px',
        }}
      >
        {whyCarii.cards.map((card, index) => (
          <RiseCard key={card.title} index={index}>
            <div
              style={{
                width: '34px',
                height: '34px',
                borderRadius: '10px',
                background: 'var(--yGlass)',
                border: '1px solid var(--yEdge)',
                display: 'grid',
                placeItems: 'center',
                font: "800 14px/1 'Plus Jakarta Sans',sans-serif",
                color: 'var(--yellow)',
              }}
            >
              {card.mark}
            </div>
            <div
              style={{
                marginTop: '16px',
                font: "700 16px/1.3 'Plus Jakarta Sans',sans-serif",
                color: 'var(--ink)',
              }}
            >
              {card.title}
            </div>
            <div
              style={{
                marginTop: '8px',
                font: "500 13.5px/1.5 'Plus Jakarta Sans',sans-serif",
                color: 'var(--muted)',
              }}
            >
              {card.body}
            </div>
          </RiseCard>
        ))}
      </div>
    </section>
  );
}
